<div cdkDrag [cdkDragData]="data">
    <div [ngClass]="data.placeholderClassName" *cdkDragPlaceholder></div>
    <div [id]="data.id" 
        class="widget-area"
        [ngClass]="data.isSelected ? 'widget-selected' : 'widget-unselected'"
        cdkDropList
        [cdkDropListConnectedTo]="dropListIds"
        [cdkDropListData]="data.children"
        [cdkDropListEnterPredicate]="isDroppableWidget"
        (cdkDropListDropped)="onDrop($event)">
        <!-- Titlebar for Widget -->         
        <div class="widget-top-bar" fxLayout="row nowrap" fxLayoutAlign="end start">                 
            <!-- <mat-icon class="drag-handler" cdkDragHandle [matBadge]="data.badge">{{data.icon}}</mat-icon> -->
            <mat-icon class="drag-handler" cdkDragHandle>drag_indicator</mat-icon>            
            <mat-label class="top-bar-title" fxFlex="grow" (click)="onSelect($event)"><b>{{data.name}}</b></mat-label>
            <mat-label class="top-bar-text" (click)="setWidth(33)">33%</mat-label>
            <mat-label class="top-bar-text" (click)="setWidth(50)">50%</mat-label>
            <mat-label class="top-bar-text" (click)="setWidth(100)">100%</mat-label>
            <mat-icon class="top-icon" (click)="onDeleteModal()">delete</mat-icon>
            <mat-icon *ngIf="!isMinimized" class="top-icon" (click)="onMinimize()">expand_less</mat-icon>
            <mat-icon *ngIf="isMinimized" class="top-icon" (click)="onMaximize()">expand_more</mat-icon>            
        </div>

        <!-- Config data for Widget --> 
        <div *ngIf="!isMinimized" fxLayout="row nowrap">
            <appMetadataWidget fxFlex="grow" [data]="data"></appMetadataWidget>
        </div>        

        <!-- Config data for Widget --> 
        <div class="widget-config" *ngIf="!isMinimized" fxLayout="row nowrap"> 
            <h5 class="block-title">{{data.name}} Settings</h5>
            <mat-form-field>            
                <input matInput label="Width" type="text" [(ngModel)]="data.width">
            </mat-form-field>
        </div>

        <!-- Validation container for Widget --> 
        <ng-container *ngFor="let widget of data.children">
            <ng-container [ngSwitch]="widget.widgetType">
                <div appWidgetsRow
                    [data]="$any(widget)"
                    [dropListIds]="dropListIds"
                    (dropListIdAdded)="onDropListIdAdded($event)"
                    *ngSwitchCase="WidgetsTypeEnum.ROW">
                </div>
                <div appWidgetsField
                    [data]="$any(widget)"
                    [dropListIds]="dropListIds"
                    (dropListIdAdded)="onDropListIdAdded($event)"                    
                    *ngSwitchCase="WidgetsTypeEnum.FIELD">
                </div>
                <div appWidgetsCheckbox     
                    [data]="$any(widget)"
                    [dropListIds]="dropListIds"
                    (dropListIdAdded)="onDropListIdAdded($event)"                
                    *ngSwitchCase="WidgetsTypeEnum.CHECKBOX">
                </div>
                <div appWidgetsRadio
                    [data]="$any(widget)"
                    [dropListIds]="dropListIds"
                    (dropListIdAdded)="onDropListIdAdded($event)"                    
                    *ngSwitchCase="WidgetsTypeEnum.RADIO">
                </div>
                <div appWidgetsInput
                    [data]="$any(widget)"
                    [dropListIds]="dropListIds"
                    (dropListIdAdded)="onDropListIdAdded($event)"                    
                    *ngSwitchCase="WidgetsTypeEnum.INPUT">
                </div>
                <div appWidgetsRealtedInput
                [data]="$any(widget)"
                [dropListIds]="dropListIds"
                (dropListIdAdded)="onDropListIdAdded($event)"                    
                *ngSwitchCase="WidgetsTypeEnum.ORDINAL_IN_SET">
            </div>
                <div appWidgetsTime
                    [data]="$any(widget)"
                    [dropListIds]="dropListIds"
                    (dropListIdAdded)="onDropListIdAdded($event)"                    
                    *ngSwitchCase="WidgetsTypeEnum.TIME_RANGE">
                </div>
                <div appWidgetsText
                    [data]="$any(widget)"
                    *ngSwitchCase="WidgetsTypeEnum.TEXT">
                </div>              
                <div appWidgetsArray
                    [data]="$any(widget)"
                    *ngSwitchCase="WidgetsTypeEnum.ARRAY">
                </div>
                <div appWidgetsQuestion
                    [data]="$any(widget)"
                    *ngSwitchCase="WidgetsTypeEnum.QUESTION">
                </div>
            </ng-container>
        </ng-container>        
    </div>
</div>
